import React from 'react'

/**
  * @class Clients
  * Show the clients logo
*/
class Clients extends React.Component {

  clients: object[] = []

  constructor(props) {
    super(props)
    /*
      TODO
      Generate it with wp-admin (json)
    */
    this.clients = [
      {"name": "Biocoop", logo: "biocoop.png"},
      {"name": "Beaugrenelle", logo: "beaugrenelle.png"},
      {"name": "Orange", logo: "orange.png"},
      {"name": "Habitat", logo: "habitat.png"},
      {"name": "Apsys", logo: "apsys.png"},
      {"name": "Renault", logo: "renault.png"},
      {"name": "BNP Paribas", logo: "bnp.png"},
      {"name": "Bosch", logo: "bosch.png"},
      {"name": "Carrefour", logo: "carrefour.png"},
      {"name": "Cetelem", logo: "cetelem.png"},
      {"name": "Essilor", logo: "essilor.png"},
      {"name": "Fred", logo: "fred.png"},
      {"name": "Nature et Découvertes", logo: "nature-et-decouvertes.png"},
      {"name": "SBM", logo: "sbm.png"},
      {"name": "EpiSaveurs", logo: "episaveurs.png"},
      {"name": "Saint-Gobain", logo: "saint-gobain.png"},
      {"name": "Microsoft", logo: "microsoft.png"},
      {"name": "Engie", logo: "engie.png"}
    ]
  }

  render() {
    /*
      TODO
      clientsList would be a method
    */
    let clientsList = this.clients.map((client, index) =>
      <div key={index} className="col-xl-2 col-lg-4 col-6">
        <img src= { process.env.PUBLIC_URL + "/images/logos/" + client.logo } alt={client.name} />
      </div>
    )

    return <section className="bg--white clients-list">
      <div className="container-fluid">
        <div className="row align-items-center center-text">
          {clientsList}
        </div>
      </div>
    </section>
  }
}

export default Clients




// WEBPACK FOOTER //
// ./src/components/Clients.jsx